<template>
  <NuxtLink to="https://fytte.jp/" target="_blank" rel="noopener">
    <img
      alt="ダイエット、運動、健康のことならFYTTE"
      src="@/assets/img/fytte.jpg"
    />
  </NuxtLink>
</template>
